import PageManager from '../page-manager';

export default class Page extends PageManager {}



// WEBPACK FOOTER //
// ./assets/js/theme/page.js